import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const styles = ({ theme }) => {
  /**
   * TODO: Import from FolksamUI once available
   */
  return {
    "@global": {
      html: {
        fontSize: "100%",
        [`@media (min-width: ${theme.screens.md}px)`]: {
          fontSize: "106.25%"
        },
        [`@media (min-width: ${theme.screens.lg}px)`]: {
          fontSize: "112.5%"
        }
      },
      body: {
        margin: 0,
        padding: 0,
        backgroundColor: theme.colors.white,
        color: theme.colors.senary1
      }
    }
  };
};

const Layout = ({ children }) => {
  return <>{children}</>;
};

Layout.propTypes = {
  children: PropTypes.node
};

export default injectSheet(styles)(Layout);
